import { useState, useRef } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import MenuDropdown from './MenuDropdown';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const location = useLocation();
  const params = useParams<{ id?: string }>();

  const isPlaylistPage = location.pathname.startsWith('/playlist/');
  const playlistId = params.id;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-light px-4 py-3 dark:border-b dark:border-gray-700 dark:bg-background-dark">
      <div className="container mx-auto flex items-center justify-between">
        {/* Left Side: App Title/Logo */}
        <Link
          to="/"
          className="flex min-h-[44px] min-w-[44px] items-center gap-2 text-xl font-semibold text-gray-800 hover:text-primary dark:text-gray-100"
        >
          <img src="/logo.png" alt="TrackToss Logo" className="h-9 w-9 object-contain" />
          TrackToss
        </Link>

        {/* Right Side: Hamburger Menu Button */}
        <div className="relative">
          <button
            onClick={toggleMenu}
            className="flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md p-2 text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 dark:text-gray-300 dark:hover:bg-gray-800"
            aria-label="Open Menu"
            aria-expanded={isMenuOpen}
            ref={buttonRef}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          <MenuDropdown
            isOpen={isMenuOpen}
            onClose={closeMenu}
            buttonRef={buttonRef}
            isPlaylistPage={isPlaylistPage}
            playlistId={playlistId}
          />
        </div>
      </div>
    </header>
  );
}
